import { h, Fragment } from "preact";
import { useContext } from "preact/hooks";
import {
  Checkmark,
  DashedSwatchOutline,
  DashedSwatchOutlineSmall,
} from "../../helpers/icons";
import { IdPrefixContext } from "../../helpers/idPrefixContext";
import {
  productOptionSwatchStyles,
  productOptionSizes,
} from "./product-option-styles";
import ProductOptionAvailabilityTooltip from "./product-option-availability-tooltip";

export default function ProductOptionSwatch({
  optionValue,
  optionName,
  disabled,
  optionVariant,
  unavailable,
  waitlist,
  updateOptionValue,
  selected,
  onClick = () => {},
  disabledSwatchStyle = productOptionSwatchStyles.default,
  optionSize = productOptionSizes.default,
}) {
  const idPrefix = useContext(IdPrefixContext);

  return (
    <label
      className={`product-options__swatch-wrapper product-options__swatch-wrapper--${optionSize}`}
      onClick={onClick}
    >
      <input
        type="radio"
        name={`${idPrefix}${optionName}`}
        value={optionValue.name}
        className="product-options__swatch-input"
        onChange={(e) => updateOptionValue(e.target.value)}
        checked={selected}
      />
      <div
        className={`product-options__swatch product-options__swatch--${optionSize}`}
      >
        <div
          className={`
            product-options__swatch-inner
            ${optionValue.swatch ? "" : "product-options__swatch-inner--placeholder"}
            ${disabled || unavailable ? `product-options__swatch-inner--disabled product-options__swatch-inner--disabled-style-${disabledSwatchStyle}` : ""}
            `}
          style={{ "--swatch-color": optionValue.swatch?.color }}
        >
          {optionValue.swatch?.image && (
            <img
              className="product-options__swatch-image"
              src={window.getSizedImageUrl(
                optionValue.swatch.image.previewImage.url,
                "100x",
              )}
              alt=""
            />
          )}
          <span className="visually-hidden">{optionValue.name}</span>
          <Checkmark />
        </div>
        {(disabled || unavailable) &&
          disabledSwatchStyle === productOptionSwatchStyles.default && (
            <div className={`product-options__swatch-disabled-slash`}></div>
          )}
        {(disabled || unavailable) &&
          disabledSwatchStyle === productOptionSwatchStyles.dashed && (
            <div className={`product-options__swatch-disabled-dashed`}>
              {optionSize == productOptionSizes.small ? (
                <DashedSwatchOutlineSmall />
              ) : (
                <DashedSwatchOutline />
              )}
            </div>
          )}
      </div>
      {waitlist && (
        <ProductOptionAvailabilityTooltip
          tooltip={window.localeStrings.product.option_join_waitlist}
          variant={optionVariant?.variant}
        />
      )}
    </label>
  );
}
